import React, { useEffect } from "react";
import Aside from "./aside";
import PageContent from "./content";
import Header from "./header";

const Layout = ({ children, titulo, header, action }) => {
  document.title = titulo || "Ibraflex - Painel";

  useEffect(() => {
    document.getElementById("tag-body").classList.remove("gray-bg");
  }, []);

  return (
    <div id="wrapper">
      <Aside />
      <div id="page-wrapper" className="gray-bg">
        <Header />
        <PageContent header={header} action={action}>
          {children}
        </PageContent>
      </div>
    </div>
  );
};

export default Layout;
